import * as React from 'react';
import { Input } from 'antd';

interface PriorityProps {
  value?: number;
  variant: GQL.IProductVariant;
  onChange?: Function;
}

interface PriorityState {
  editing: boolean;
  priority?: number;
}

class Priority extends React.Component<PriorityProps, PriorityState> {

  constructor(props: PriorityProps) {
    super(props);

    this.state = {
      editing: false,
      priority: props.value,
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleFocus = (event) => {
    event.target.select();
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit();
    }
    if (e.key === 'Escape') {
      this.setState({
        editing: false,
        priority: this.props.value,
      });
    }
  };

  handleSubmit = () => {
    this.setState({
      editing: false,
    });
    if (this.props.onChange && this.state.priority !== this.props.value) {
      this.props.onChange(this.props.variant.productId, this.state.priority);
    }
  };

  handleChange = (e: any) => {
    this.setState({
      priority: parseInt(e.target.value),
    });
  };

  componentWillReceiveProps(nextProps: PriorityProps) {
    if (this.state.priority !== nextProps.value) {
      this.setState({ 
        priority: nextProps.value 
      });
    }
  }

  render() {
    const { priority } = this.state;

    const style = { height: '21px', width: '70%' };

    if (this.state.editing) {
      return (
        <input
          autoFocus={true}
          value={priority ? priority.toString() : ''}
          style={{ ...style, textAlign: 'center', border: '1px solid #DDD' }}
          onFocus={this.handleFocus}
          onKeyDown={this.handleKeyDown}
          onBlur={this.handleSubmit}
          onChange={this.handleChange}
        />
      );
    }

    return (
      <span
        style={{ ...style, width: '100%', display: 'block' }}
        onClick={() => this.setState({ editing: true })}
      >
        {priority}
      </span>
    );
  }
}

export default Priority;


// WEBPACK FOOTER //
// ./src/scenes/Catalog/components/Priority.tsx